import './error.css'
import { Button } from '../../components/Button';

import Ilustration from 'base/src/assets/images/page-not-found.svg?react';
import { styled } from 'styled-components';
import { useNavigate } from 'react-router-dom'

interface Props {
  size?: string;
}

export default function PageNotFound(/* props: Props */){
  const navigate = useNavigate();

  function handleGoBack() {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  }

  return (
    <Container>
      <Containertext>
        <Title>404</Title>
        <Subtitle>Você não passará! (E nem essa página, porque ela não existe.)</Subtitle>
        <Button full={true} size='lg' onClick={handleGoBack} >Voltar</Button>
      </Containertext>
      <SIlustration size='30rem' />
    </Container>
  )
}

export const Container = styled.div`
  font-family: Roboto;
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const SIlustration = styled(Ilustration) <Props>`
  width: ${props => props.size};
  min-width: ${props => props.size};
  height: ${props => props.size};
  min-height: ${props => props.size};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Containertext = styled.div`
  font-family: Roboto;
  width: 400px;
  gap: 15px;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h1`
  color: ${props => props.theme.colors.primary};
  font-size: 100px;
`;
export const Subtitle = styled.h3`
  color: ${props => props.theme.colors.primary}
  
`;
